module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/IECQ QC 080000-2017.dbe2534c.png";